// import React, { useRef, useState, useEffect } from "react";
// import "./DppScheduling.css";
// import DropDown from "./ReflectDropdownClassic";
// import InputComponent from "../TestScheduling/Input-testscheduling";
// import { useSearchParams } from "react-router-dom";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import introgativeImgBlue from "../../../Assets/Images/CommanImages/IntrogativeBlue.png";
// import TextEditor from "./TextEditor";
// import InputComponent2 from "./InputComponent";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import SucessImg from "../../../Assets/Images/CommanImages/Informative.png";
// import MultiSelectSearchDropdown from "./MultiDropdownClassic";
// import { useLocation } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
// import Colors from "../../../Constants/Colors";

// import { PUT, GET, POST } from "../../../Api/HttpsMethods";
// import EndPoints from "../../../Api/EndPoints";
// import BlankDropdown from "./BlankDropdown";
// import RejectModal from "../../../Components/RejectModal/RejectModal";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";

// const DPPSchedulingClone = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
// }) => {
//   const location = useLocation();
//   const dppData = location.state;
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();

//   useEffect(() => {
//     if (dataClient) {
//       const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
//       const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//       const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
//       sessionStorage.setItem("user_name", userName);
//       sessionStorage.setItem("clientBranchId", clientBranchId);
//       sessionStorage.setItem("clientId", clientId);
//     }
//   }, [dataClient]);

//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || sessionStorage.getItem("user_name") || "";
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || sessionStorage.getItem("clientBranchId") || null;
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || sessionStorage.getItem("clientId") || null;

//   const [showRejectModal, setShowRejectModal] = useState(false);
//   const [canEditInstructions, setCanEditInstructions] = useState(true);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [canEditBatch, setCanEditBatch] = useState(true);
//   const [canEditStartDate, setCanEditStartDate] = useState(true);
//   const [canDeleteSchedule, setCanDeleteSchedule] = useState(true);
//   const [isAttempted, setIsAttempted] = useState(false);

//   // ── Refs for last saved dates — validation baseline ───────────────────────
//   // These are set when API data loads and updated on successful save.
//   // Validation compares against these, not against current state,
//   // so unsaved changes don't affect the validation reference point.
//   const savedStartDateRef = useRef(null);
//   const savedEndDateRef   = useRef(null);

//   const queryParams = new URLSearchParams(location.search);
//   const dppScheduleId = queryParams.get("IDs");
//   const [DPPScheduleData, setDPPScheduleData] = useState(null);
//   const [selectedChapterId, setSelectedChapterId] = useState([]);
//   const [selectedChapterName, setSelectedChapterName] = useState("");
//   const [selectedTopicId, setSelectedTopicId] = useState([]);
//   const [selectedTopicName, setSelectedTopicName] = useState("");
//   const [instructionsHtml, setInstructionsHtml] = useState("");
//   const [selectedQuestionPaperId, setSelectedQuestionPaperId] = useState("");
//   const [selectedQuestionPaperName, setSelectedQuestionPaperName] = useState("");
//   const [selectedQuestionPaperDescription, setSelectedQuestionPaperDescription] = useState("");
//   const [selectedQuestionPaperCreatedBy, setSelectedQuestionPaperCreatedBy] = useState("");
//   const [testTemplates, setTestTemplates] = useState([]);
//   const [testStartDate, setTestStartDate] = useState(null);
//   const [testEndDate, setTestEndDate] = useState(null);
//   const [courses, setCourses] = useState([]);
//   const [subjects, setSubjects] = useState([]);
//   const [chapters, setChapters] = useState([]);
//   const [classes, setClasses] = useState([]);
//   const [topics, setTopics] = useState([]);
//   const [questionPapers, setQuestionPapers] = useState([]);
//   const [dppName, setDppName] = useState("");
//   const [DppDescription, setDppDescription] = useState("");
//   const [CordinatorName, setCordinatorName] = useState("");
//   const [batches, setBatches] = useState([]);
//   const [selectedCourseId, setSelectedCourseId] = useState("");
//   const [selectedCourseName, setSelectedCourseName] = useState("");
//   const [selectedBatchId, setSelectedBatchId] = useState("");
//   const [selectedBatchName, setSelectedBatchName] = useState("");
//   const [selectedSubjectId, setSelectedSubjectId] = useState("");
//   const [selectedSubjectName, setSelectedSubjectName] = useState("");
//   const [selectedClassId, setSelectedClassId] = useState("");
//   const [selectedClassName, setSelectedClassName] = useState("");
//   const [selectedStudentGroup, setSelectedStudentGroup] = useState([]);
//   const accessToken = localStorage.getItem("other");
//   const [quesPaperSubjects, setQuesPaperSubjects] = useState("");
//   const [serverCurrentTime, setServerCurrentTime] = useState(null);

//   // ── Fetch server current time ─────────────────────────────────────────────
//   useEffect(() => {
//     const fetchServerTime = async () => {
//       try {
//         const token = localStorage.getItem("other");
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-current-datetime/`,
//           { headers: { accept: "application/json", Authorization: `Bearer ${token}` } }
//         );
//         const data = await response.json();
//         if (data?.status === 200 && data?.data) {
//           const { current_date, current_time } = data.data;
//           setServerCurrentTime(`${current_date}T${current_time}`);
//         }
//       } catch (error) {
//         console.error("Error fetching server time:", error);
//         setServerCurrentTime(new Date().toISOString());
//       }
//     };
//     fetchServerTime();
//   }, []);

//   // ── getCurrentDateTime: server time + 15 min ─────────────────────────────
//   const getCurrentDateTime = () => {
//     const base = serverCurrentTime ? new Date(serverCurrentTime) : new Date();
//     base.setMinutes(base.getMinutes() + 15);
//     const year  = base.getFullYear();
//     const month = String(base.getMonth() + 1).padStart(2, "0");
//     const day   = String(base.getDate()).padStart(2, "0");
//     const hours = String(base.getHours()).padStart(2, "0");
//     const mins  = String(base.getMinutes()).padStart(2, "0");
//     return `${year}-${month}-${day}T${hours}:${mins}`;
//   };

//   // ── getMinEndDate: start + 24 hours ──────────────────────────────────────
//   const getMinEndDate = (startDateTime) => {
//     const base = startDateTime || testStartDate;
//     if (!base) return "";
//     const startDate = new Date(base);
//     startDate.setHours(startDate.getHours() + 24);
//     return startDate.toISOString().slice(0, 16);
//   };

//   const formatDateTimeForInput = (dateTimeString) => {
//     if (!dateTimeString) return "";
//     let formatted = dateTimeString;
//     if (formatted.includes(" ") && !formatted.includes("T")) {
//       formatted = formatted.replace(" ", "T");
//     }
//     return formatted.slice(0, 16);
//   };

//   const isBeforeStartDate = () => {
//     if (!testStartDate) return true;
//     const startDate = new Date(testStartDate);
//     const currentDate = new Date();
//     return currentDate < startDate;
//   };

//   const canDeleteAfterStart = () => {
//     return !isAttempted;
//   };

//   useEffect(() => {
//     const fetchDPPscheduleDetails = async () => {
//       if (!dppScheduleId) return;
//       const url = `${EndPoints.GetDPPScheduleDetails}?dpp_schedule_id=${dppScheduleId}`;
//       const response = await GET.withToken(url, {
//         setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg,
//       });

//       const data = response?.data;
//       if (data) {
//         setDPPScheduleData(data);
//         setSelectedCourseId(data.course_id);
//         setSelectedCourseName(data.course_name);
//         setSelectedBatchId(data.batch_id);
//         setSelectedBatchName(data.batch_name);
//         setSelectedClassId(data.class_id);
//         setSelectedClassName(data.class_name);
//         setSelectedSubjectId(data.subject_id);
//         setSelectedSubjectName(data.subject_name);
//         setSelectedChapterId([data.chapter_id]);
//         setSelectedChapterName(data.chapter_name);
//         setSelectedTopicId([data.topic_id]);
//         setSelectedTopicName(data.topic_name);
//         setSelectedQuestionPaperId(data.ques_paper_id);
//         setSelectedQuestionPaperName(data.ques_paper_name);
//         setSelectedQuestionPaperDescription(data.ques_paper_desc);
//         setSelectedQuestionPaperCreatedBy(data.ques_paper_created_by);
//         setDppName(data.dpp_name);
//         setDppDescription(data.dpp_desc);
//         setCordinatorName(data.batch_coordinator_name || "");
//         setTestStartDate(data.dpp_window_start);
//         setTestEndDate(data.dpp_window_end);
//         setInstructionsHtml(data.instructions_html);
//         setQuesPaperSubjects(data.ques_paper_subjects);
//         setSelectedStudentGroup(data.student_group_names);
//         setIsAttempted(data.is_attempted || false);

//         // ── Store last saved dates as validation baseline ──────────────────
//         savedStartDateRef.current = data.dpp_window_start;
//         savedEndDateRef.current   = data.dpp_window_end;

//         const beforeStart = () => {
//           if (!data.dpp_window_start) return true;
//           const startDate  = new Date(data.dpp_window_start);
//           const currentDate = data.current_time ? new Date(data.current_time) : new Date();
//           return currentDate < startDate;
//         };
//         const beforeStartResult = beforeStart();
//         setCanEditBatch(beforeStartResult);
//         setCanEditStartDate(beforeStartResult);
//         setCanEditInstructions(beforeStartResult);
//         setCanDeleteSchedule(beforeStartResult || !data.is_attempted);
//       }
//     };

//     fetchDPPscheduleDetails();
//   }, [dppScheduleId]);

//   const handleCancelDppScheduleWithComment = async (comment) => {
//     const payload = {
//       username: userName,
//       dpp_schedule_id: Number(dppScheduleId),
//       comment: comment,
//     };

//     const response = await PUT.withToken(EndPoints.CancelDppSchedule, payload, {
//       setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg,
//     });

//     if (response && response.status === 200) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{response.message || "DPP schedule cancelled successfully!"}</span>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       setActiveImg(SucessImg);
//       setTimeout(() => navigate(-1), 1000);
//     } else if (response) {
//       setMessageBox("Failed to cancel DPP Schedule: " + response.message);
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//     }
//   };

//   useEffect(() => {
//     if (!userName || !clientBranchId) return;
//     const fetchTestTemplates = async () => {
//       const url = `${EndPoints.GetInstructionTemplateList}?username=${userName}&branch_id=${clientBranchId}`;
//       const data = await GET.withToken(url, {
//         setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg,
//       });
//       if (data) setTestTemplates(data);
//     };
//     fetchTestTemplates();
//   }, [userName, clientBranchId]);

//   useEffect(() => {
//     const fetchBatches = async () => {
//       if (!selectedCourseId) return;
//       const url = `${EndPoints.GetBatchByCourse}?course_id=${selectedCourseId}`;
//       const data = await GET.noToken(url, {
//         setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg,
//       });
//       if (Array.isArray(data?.[0])) {
//         setBatches(selectedClassId ? data[0].filter((batch) => batch.class_id === selectedClassId) : data[0]);
//       } else setBatches([]);
//     };
//     fetchBatches();
//   }, [selectedCourseId, selectedClassId]);

//   useEffect(() => {
//     if (DPPScheduleData?.course_id) setSelectedCourseId(Number(DPPScheduleData.course_id));
//   }, [DPPScheduleData]);

//   useEffect(() => {
//     if (!selectedBatchId || !batches.length) return;
//     const matchedBatch = batches.find((b) => b.batch_id === selectedBatchId);
//     if (matchedBatch) setSelectedBatchName(matchedBatch.batch_name);
//   }, [batches, selectedBatchId]);

//   useEffect(() => {
//     const fetchSubjects = async () => {
//       if (!selectedCourseId) return;
//       const url = `${EndPoints.GetSubjectsByCourse}?course_id=${selectedCourseId}`;
//       const data = await GET.noToken(url, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
//       if (data) setSubjects(data);
//     };
//     fetchSubjects();
//   }, [selectedCourseId]);

//   useEffect(() => {
//     const fetchChapters = async () => {
//       if (!selectedSubjectId) return;
//       const url = `${EndPoints.GetChaptersBySubject}?subject_id=${selectedSubjectId}`;
//       const data = await GET.noToken(url, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
//       if (data) setChapters(data);
//     };
//     fetchChapters();
//   }, [selectedSubjectId]);

//   useEffect(() => {
//     const fetchTopics = async () => {
//       if (!selectedChapterId || !Array.isArray(selectedChapterId) || selectedChapterId.length === 0) {
//         setTopics([]); return;
//       }
//       const data = await POST.withToken(EndPoints.TopicsByChapterList, selectedChapterId, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
//       if (data && data.status_code === 200 && Array.isArray(data.data)) setTopics(data.data);
//       else setTopics([]);
//     };
//     fetchTopics();
//   }, [selectedChapterId]);

//   useEffect(() => {
//     const fetchClasses = async () => {
//       const data = await GET.noToken(EndPoints.GetClasses, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
//       if (data) setClasses(data);
//     };
//     fetchClasses();
//   }, []);

//   const isCancelled = searchParams.get("isCancelled") === "true";

//   // ── handleSave — all date validation happens here ─────────────────────────
//   const handleSave = async () => {
//     // ── Validate start date (only if it was changed from saved value) ─────────
//     const startWasEdited = testStartDate !== savedStartDateRef.current;
//     if (startWasEdited && canEditStartDate) {
//       const minAllowed = getCurrentDateTime(); // server time + 15 min
//       if (testStartDate && testStartDate < minAllowed) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 DPP window start must be at least 15 minutes from current time.
//                 Please correct the start time before saving.
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg); setIsMessageBoxVisible(true); return;
//       }
//     }

//     // ── Validate end date (only if it was changed from saved value) ───────────
//     const endWasEdited = testEndDate !== savedEndDateRef.current;
//     if (endWasEdited) {
//       // End cannot be reduced below last saved value
//       const savedEnd = savedEndDateRef.current;
//       if (savedEnd && testEndDate < savedEnd) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>DPP window end can only be extended beyond the last saved value, not reduced.</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg); setIsMessageBoxVisible(true); return;
//       }
//     }

//     // ── End must be after start ───────────────────────────────────────────────
//     if (testStartDate && testEndDate && testEndDate <= testStartDate) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>DPP window end must be after the DPP window start.</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg); setIsMessageBoxVisible(true); return;
//     }

//     // ── End must be at least 24 hours after start ─────────────────────────────
//     if (testStartDate && testEndDate && testEndDate < getMinEndDate(testStartDate)) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>DPP window end must be at least 24 hours after the start time.</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg); setIsMessageBoxVisible(true); return;
//     }

//     const payload = {
//       ques_paper_id: selectedQuestionPaperId,
//       dpp_name: dppName,
//       dpp_desc: DppDescription,
//       batch_id: selectedBatchId,
//       dpp_window_start: testStartDate,
//       dpp_window_end: testEndDate,
//       username: userName,
//       status: 1,
//     };

//     if (canEditInstructions) {
//       payload.instructions_html = instructionsHtml;
//     }

//     const url = `${EndPoints.PutUpdateDppSchedule}?dpp_schedule_id=${dppScheduleId}`;
//     const data = await PUT.withToken(url, payload, {
//       setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg,
//     });

//     if (data && data.status === 200) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{data.message || "DPP schedule updated successfully!"}</span>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       setActiveImg(SucessImg);
//       // ── Update saved refs and lock form back to read-only on success ──────
//       savedStartDateRef.current = testStartDate;
//       savedEndDateRef.current   = testEndDate;
//       setIsEditMode(false);
//       setTimeout(() => { navigate(-1); }, 1000);
//     } else if (data) {
//       setMessageBox("Failed to update DPP Schedule: " + (data.detail || data.message));
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       // ── Keep form in edit mode on failure so user can correct ────────────
//     }
//   };

//   // ── Free date handlers — just update state, validation on SAVE ────────────
//   const handleStartDateChange = (e) => {
//     if (!canEditStartDate) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Start date cannot be changed after the DPP window has started.</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg); setIsMessageBoxVisible(true); return;
//     }
//     const newStartDate = e.target.value;
//     setTestStartDate(newStartDate);
//     // Auto-fill end to start + 24h (UX convenience, not validation)
//     if (newStartDate) setTestEndDate(getMinEndDate(newStartDate));
//   };

//   const handleDownload = async () => {
//     try {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Downloading DPP, please wait...</span>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       setActiveImg(false);

//       const url = `${EndPoints.PDF_DOWNLOAD_DPP_SCHEDULE}?dpp_schedule_id=${dppScheduleId}`;
//       const response = await fetch(url, { method: "GET", headers: { Authorization: `Bearer ${accessToken}` } });
//       if (!response.ok) throw new Error("Failed to download PDF");

//       const blob = await response.blob();
//       const downloadUrl = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.download = dppName ? `${dppName.replace(/\.pdf$/i, "")}.pdf` : `dpp_${dppScheduleId}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);

//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>DPP downloaded successfully!</span>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       setActiveImg(SucessImg);
//       setTimeout(() => setIsMessageBoxVisible(false), 2000);
//     } catch (err) {
//       console.error(err);
//       setMessageBox("Error downloading PDF");
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//     }
//   };

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">DPP Scheduling</span>
//         <div className="cr-header-btn-container" style={{ minWidth: "fit-content", maxWidth: "fit-content", gap: "12px" }}>
//           <button
//             className="create-test-section-btn"
//             style={{ width: "100px", padding: "0 14px", borderWidth: "2px", borderStyle: "solid" }}
//             onClick={() => navigate(-1)}
//           >
//             CANCEL
//           </button>

//           {!isEditMode && canDeleteSchedule && !isCancelled && (
//             <button
//               className="create-test-section-btn"
//               style={{ width: "100px", padding: "0 14px", borderWidth: "2px", borderStyle: "solid" }}
//               onClick={() => setShowRejectModal(true)}
//             >
//               DELETE
//             </button>
//           )}

//           {!isEditMode ? (
//             <button
//               className="create-test-section-btn"
//               style={{
//                 width: "100px", padding: "0 14px", borderWidth: "2px", borderStyle: "solid",
//                 backgroundColor: isCancelled ? "#d3d3d3" : "",
//                 cursor: isCancelled ? "not-allowed" : "pointer",
//                 opacity: isCancelled ? 0.6 : 1,
//               }}
//               onClick={!isCancelled ? () => setIsEditMode(true) : undefined}
//               disabled={isCancelled}
//             >
//               EDIT
//             </button>
//           ) : (
//             <button
//               className="create-test-section-btn"
//               style={{ width: "100px", padding: "0 14px", borderWidth: "2px", borderStyle: "solid" }}
//               onClick={handleSave}
//             >
//               SAVE
//             </button>
//           )}

//           <button
//             className="create-test-section-btn"
//             style={{ width: "100px", padding: "0 14px", borderWidth: "2px", borderStyle: "solid" }}
//             onClick={handleDownload}
//           >
//             DOWNLOAD
//           </button>
//         </div>
//       </div>

//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header"><label>QUESTION PAPER DETAIL</label></div>
//         </div>

//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div><InputComponent label="Course" style={{ width: "100%" }} value={selectedCourseName || ""} isRequired={false} disable={true} /></div>
//               <div><InputComponent label="Class" style={{ width: "100%" }} value={selectedClassName || ""} isRequired={false} disable={true} /></div>
//               <div><InputComponent label="Batch Name" style={{ width: "100%" }} value={selectedBatchName || ""} isRequired={false} disable={true} /></div>
//               <div><InputComponent label="Student Group" style={{ width: "100%" }} value={selectedStudentGroup || ""} isRequired={false} disable={true} /></div>
//               <div><InputComponent label="Subject" style={{ width: "100%" }} value={selectedSubjectName || ""} isRequired={false} disable={true} /></div>
//               <div><InputComponent label="Chapter" style={{ width: "100%" }} value={selectedChapterName || ""} isRequired={false} disable={true} /></div>
//               <div><InputComponent label="Topic" style={{ width: "100%" }} value={selectedTopicName || ""} isRequired={false} disable={true} /></div>
//               <div><InputComponent label="Question Paper Name" style={{ width: "100%" }} value={selectedQuestionPaperName || ""} isRequired={false} disable={true} /></div>
//               <div><InputComponent label="Question Paper Subjects" style={{ width: "100%" }} value={quesPaperSubjects} isRequired={false} disable={true} /></div>
//               <div><InputComponent label="Question Paper Created By" style={{ width: "100%" }} value={selectedQuestionPaperCreatedBy} isRequired={false} disable={true} /></div>
//               <div style={{ gridColumn: "2 / 4" }}><InputComponent label="Question Paper Description" style={{ width: "100%" }} value={selectedQuestionPaperDescription} isRequired={false} disable={true} /></div>
//               <div>
//                 <FormInputs label="DPP Name" value={dppName} onChange={(e) => setDppName(e.target.value)} placeholder="Enter DPP name" style={{ width: "100%" }} disabled={!isEditMode} />
//               </div>
//               <div style={{ gridColumn: "2 / 4" }}>
//                 <FormInputs label="Description" value={DppDescription} onChange={(e) => setDppDescription(e.target.value)} placeholder="Enter Description" style={{ width: "100%" }} disabled={!isEditMode} />
//               </div>
//               <div>
//                 <InputComponent label="Batch Coordinator Name" style={{ width: "100%" }} value={CordinatorName} isRequired={false} disable={true} />
//               </div>

//               {/* ── DPP Window Start — free input, all validation on SAVE ─── */}
//               <FormInputs
//                 label="DPP Window Start"
//                 type="datetime-local"
//                 value={testStartDate ? formatDateTimeForInput(testStartDate) : ""}
//                 min={getCurrentDateTime()}
//                 onChange={handleStartDateChange}
//                 style={{
//                   width: "100%",
//                   opacity: isEditMode && canEditStartDate ? 1 : Colors.opacity,
//                   cursor: isEditMode && canEditStartDate ? "text" : "not-allowed",
//                 }}
//                 disabled={!isEditMode || !canEditStartDate}
//               />

//               {/* ── DPP Window End — free input, all validation on SAVE ───── */}
//               <FormInputs
//                 label="DPP Window End"
//                 type="datetime-local"
//                 min={getMinEndDate()}
//                 value={testEndDate ? formatDateTimeForInput(testEndDate) : ""}
//                 onChange={(e) => {
//                   // Just update freely — validation on SAVE
//                   setTestEndDate(e.target.value);
//                 }}
//                 style={{
//                   width: "100%",
//                   opacity: isEditMode ? 1 : Colors.opacity,
//                   cursor: isEditMode ? "text" : "not-allowed",
//                 }}
//                 disabled={!isEditMode}
//               />
//             </div>
//           </div>

//           <div style={{ padding: "0px 60px 20px 20px" }}>
//             <div style={{ position: "relative" }}>
//               {(!isEditMode || !canEditInstructions) && (
//                 <div
//                   style={{
//                     position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
//                     background: Colors.color5, zIndex: 10, pointerEvents: "all",
//                     cursor: "not-allowed", borderRadius: "4px",
//                   }}
//                 />
//               )}
//               <TextEditor
//                 templates={testTemplates}
//                 value={instructionsHtml}
//                 setValue={(newValue) => {
//                   if (!canEditInstructions && isEditMode) {
//                     setMessageBox(
//                       <div className="Container-messageBOX">
//                         <div className="messagebox-insider1">
//                           <div className="loader-tc"></div>
//                           <span>Instructions cannot be changed after the DPP window has started.</span>
//                         </div>
//                       </div>
//                     );
//                     setActiveImg(ErrorImg); setIsMessageBoxVisible(true); return;
//                   }
//                   setInstructionsHtml(newValue);
//                 }}
//                 disabled={!canEditInstructions}
//               />
//             </div>
//           </div>
//         </div>
//       </div>

//       <RejectModal
//         isOpen={showRejectModal}
//         onClose={() => setShowRejectModal(false)}
//         onSubmit={(comment) => { setShowRejectModal(false); handleCancelDppScheduleWithComment(comment); }}
//         title="Cancel DPP Schedule"
//         placeholder="Enter reason for cancelling the DPP schedule..."
//         setMessageBox={setMessageBox}
//         setIsMessageBoxVisible={setIsMessageBoxVisible}
//         setActiveImg={setActiveImg}
//         errorImg={ErrorImg}
//       />
//     </div>
//   );
// };

// export default DPPSchedulingClone;

import React, { useRef, useState, useEffect } from "react";
import "./DppScheduling.css";
import DropDown from "./ReflectDropdownClassic";
import InputComponent from "../TestScheduling/Input-testscheduling";
import { useSearchParams } from "react-router-dom";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import introgativeImgBlue from "../../../Assets/Images/CommanImages/IntrogativeBlue.png";
import TextEditor from "./TextEditor";
import InputComponent2 from "./InputComponent";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import SucessImg from "../../../Assets/Images/CommanImages/Informative.png";
import MultiSelectSearchDropdown from "./MultiDropdownClassic";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Colors from "../../../Constants/Colors";
import { PUT, GET, POST } from "../../../Api/HttpsMethods";
import EndPoints from "../../../Api/EndPoints";
import BlankDropdown from "./BlankDropdown";
import RejectModal from "../../../Components/RejectModal/RejectModal";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import SelectedValueDropdwon from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown"

const DPPSchedulingClone = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
}) => {
  const location = useLocation();
  const dppData = location.state;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (dataClient) {
      const userName =
        dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
      const clientBranchId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
      const clientId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
      sessionStorage.setItem("user_name", userName);
      sessionStorage.setItem("clientBranchId", clientBranchId);
      sessionStorage.setItem("clientId", clientId);
    }
  }, [dataClient]);

  const userName =
    dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
    sessionStorage.getItem("user_name") ||
    "";
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
    sessionStorage.getItem("clientBranchId") ||
    null;
  const clientId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
    sessionStorage.getItem("clientId") ||
    null;

  const [showRejectModal, setShowRejectModal] = useState(false);
  const [canEditInstructions, setCanEditInstructions] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [canEditBatch, setCanEditBatch] = useState(true);
  const [canEditStartDate, setCanEditStartDate] = useState(true);
  const [canDeleteSchedule, setCanDeleteSchedule] = useState(true);
  const [isAttempted, setIsAttempted] = useState(false);

  // ── Refs for last saved dates — validation baseline ───────────────────────
  // These are set when API data loads and updated on successful save.
  // Validation compares against these, not against current state,
  // so unsaved changes don't affect the validation reference point.
  const savedStartDateRef = useRef(null);
  const savedEndDateRef = useRef(null);

  const queryParams = new URLSearchParams(location.search);
  const dppScheduleId = queryParams.get("IDs");
  const [DPPScheduleData, setDPPScheduleData] = useState(null);
  const [selectedChapterId, setSelectedChapterId] = useState([]);
  const [selectedChapterName, setSelectedChapterName] = useState("");
  const [selectedTopicId, setSelectedTopicId] = useState([]);
  const [selectedTopicName, setSelectedTopicName] = useState("");
  const [instructionsHtml, setInstructionsHtml] = useState("");
  const [selectedQuestionPaperId, setSelectedQuestionPaperId] = useState("");
  const [selectedQuestionPaperName, setSelectedQuestionPaperName] =
    useState("");
  const [
    selectedQuestionPaperDescription,
    setSelectedQuestionPaperDescription,
  ] = useState("");
  const [selectedQuestionPaperCreatedBy, setSelectedQuestionPaperCreatedBy] =
    useState("");
  const [testTemplates, setTestTemplates] = useState([]);
  const [testStartDate, setTestStartDate] = useState(null);
  const [testEndDate, setTestEndDate] = useState(null);
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [classes, setClasses] = useState([]);
  const [topics, setTopics] = useState([]);
  const [questionPapers, setQuestionPapers] = useState([]);
  const [dppName, setDppName] = useState("");
  const [DppDescription, setDppDescription] = useState("");
  const [CordinatorName, setCordinatorName] = useState("");
  const [batches, setBatches] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedCourseName, setSelectedCourseName] = useState("");
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [selectedBatchName, setSelectedBatchName] = useState("");
  const [selectedSubjectId, setSelectedSubjectId] = useState("");
  const [selectedSubjectName, setSelectedSubjectName] = useState("");
  const [selectedClassId, setSelectedClassId] = useState("");
  const [selectedClassName, setSelectedClassName] = useState("");
  const [selectedStudentGroup, setSelectedStudentGroup] = useState([]);
  const [selectedStudentGroupIds, setSelectedStudentGroupIds] = useState([]);
  const accessToken = localStorage.getItem("other");
  const [quesPaperSubjects, setQuesPaperSubjects] = useState("");
  const [serverCurrentTime, setServerCurrentTime] = useState(null);
  const [fillInTheBlanksSuggestions, setFillInTheBlanksSuggestions] = useState(null);

  // ── Fetch server current time ─────────────────────────────────────────────
  useEffect(() => {
    const fetchServerTime = async () => {
      try {
        const token = localStorage.getItem("other");
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-current-datetime/`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        if (data?.status === 200 && data?.data) {
          const { current_date, current_time } = data.data;
          setServerCurrentTime(`${current_date}T${current_time}`);
        }
      } catch (error) {
        console.error("Error fetching server time:", error);
        setServerCurrentTime(new Date().toISOString());
      }
    };
    fetchServerTime();
  }, []);

  // ── getCurrentDateTime: server time + 15 min ─────────────────────────────
  const getCurrentDateTime = () => {
    const base = serverCurrentTime ? new Date(serverCurrentTime) : new Date();
    base.setMinutes(base.getMinutes() + 15);
    const year = base.getFullYear();
    const month = String(base.getMonth() + 1).padStart(2, "0");
    const day = String(base.getDate()).padStart(2, "0");
    const hours = String(base.getHours()).padStart(2, "0");
    const mins = String(base.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${mins}`;
  };

  // ── getMinEndDate: start + 24 hours ──────────────────────────────────────
  const getMinEndDate = (startDateTime) => {
    const base = startDateTime || testStartDate;
    if (!base) return "";
    const startDate = new Date(base);
    startDate.setHours(startDate.getHours() + 24);
    return startDate.toISOString().slice(0, 16);
  };

  const formatDateTimeForInput = (dateTimeString) => {
    if (!dateTimeString) return "";
    let formatted = dateTimeString;
    if (formatted.includes(" ") && !formatted.includes("T")) {
      formatted = formatted.replace(" ", "T");
    }
    return formatted.slice(0, 16);
  };

  const isBeforeStartDate = () => {
    if (!testStartDate) return true;
    const startDate = new Date(testStartDate);
    const currentDate = new Date();
    return currentDate < startDate;
  };

  const canDeleteAfterStart = () => {
    return !isAttempted;
  };

  useEffect(() => {
    const fetchDPPscheduleDetails = async () => {
      if (!dppScheduleId) return;
      const url = `${EndPoints.GetDPPScheduleDetails}?dpp_schedule_id=${dppScheduleId}`;
      const response = await GET.withToken(url, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });

      const data = response?.data;
      if (data) {
        setDPPScheduleData(data);
        setSelectedCourseId(data.course?.course_id ?? "");
        setSelectedCourseName(data.course?.course_name ?? "");
        setSelectedBatchId(Array.isArray(data.batch_list) ? data.batch_list.map((b) => b.batch_id) : []);
        setSelectedBatchName(Array.isArray(data.batch_list) ? data.batch_list.map((b) => b.batch_name).join(", ") : "");
        setSelectedClassId(data.class_list?.[0]?.class_id ?? "");
        setSelectedClassName(data.class_list?.[0]?.class_name ?? "");
        setSelectedSubjectId(data.subject_id);
        setSelectedSubjectName(data.subject_name);
        setSelectedChapterId([data.chapter_id]);
        setSelectedChapterName(data.chapter_name);
        setSelectedTopicId([data.topic_id]);
        setSelectedTopicName(data.topic_name);
        setSelectedQuestionPaperId(data.ques_paper_id);
        setSelectedQuestionPaperName(data.ques_paper_name);
        setSelectedQuestionPaperDescription(data.ques_paper_desc);
        setSelectedQuestionPaperCreatedBy(data.ques_paper_created_by);
        setDppName(data.dpp_name);
        setDppDescription(data.dpp_desc);
        setCordinatorName(data.batch_coordinator_name || "");
        setTestStartDate(data.dpp_window_start);
        setTestEndDate(data.dpp_window_end);
        setInstructionsHtml(data.instructions_html);
        setQuesPaperSubjects(data.ques_paper_subjects);
        setSelectedStudentGroup(data.student_group_names);
        setSelectedStudentGroupIds(Array.isArray(data.student_group_ids) ? data.student_group_ids : []);
        setIsAttempted(data.is_attempted || false);
        setFillInTheBlanksSuggestions(data.fill_in_the_blanks_suggestions ?? null);

        // ── Store last saved dates as validation baseline ──────────────────
        savedStartDateRef.current = data.dpp_window_start;
        savedEndDateRef.current = data.dpp_window_end;

        const beforeStart = () => {
          if (!data.dpp_window_start) return true;
          const startDate = new Date(data.dpp_window_start);
          const currentDate = data.current_time
            ? new Date(data.current_time)
            : new Date();
          return currentDate < startDate;
        };
        const beforeStartResult = beforeStart();
        setCanEditBatch(beforeStartResult);
        setCanEditStartDate(beforeStartResult);
        setCanEditInstructions(beforeStartResult);
        setCanDeleteSchedule(beforeStartResult || !data.is_attempted);
      }
    };

    fetchDPPscheduleDetails();
  }, [dppScheduleId]);

  const handleCancelDppScheduleWithComment = async (comment) => {
    const payload = {
      username: userName,
      dpp_schedule_id: Number(dppScheduleId),
      comment: comment,
    };

    const response = await PUT.withToken(EndPoints.CancelDppSchedule, payload, {
      setMessageBox,
      setIsMessageBoxVisible,
      setActiveImg,
      ErrorImg,
    });

    if (response && response.status === 200) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              {response.message || "DPP schedule cancelled successfully!"}
            </span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(SucessImg);
      setTimeout(() => navigate(-1), 1000);
    } else if (response) {
      setMessageBox("Failed to cancel DPP Schedule: " + response.message);
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
    }
  };

  useEffect(() => {
    if (!userName || !clientBranchId) return;
    const fetchTestTemplates = async () => {
      const url = `${EndPoints.GetInstructionTemplateList}?username=${userName}&branch_id=${clientBranchId}`;
      const data = await GET.withToken(url, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });
      if (data) setTestTemplates(data);
    };
    fetchTestTemplates();
  }, [userName, clientBranchId]);

  // useEffect(() => {
  //   const fetchBatches = async () => {
  //     if (!selectedCourseId) return;
  //     const url = `${EndPoints.GetBatchByCourse}?course_id=${selectedCourseId}`;
  //     const data = await GET.noToken(url, {
  //       setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg,
  //     });
  //     if (Array.isArray(data?.[0])) {
  //       setBatches(selectedClassId ? data[0].filter((batch) => batch.class_id === selectedClassId) : data[0]);
  //     } else setBatches([]);
  //   };
  //   fetchBatches();
  // }, [selectedCourseId, selectedClassId]);
  useEffect(() => {
    const fetchBatches = async () => {
      if (!selectedCourseId) return;
      const url = `${EndPoints.GetBatchByCourse}?course_id=${selectedCourseId}`;
      const data = await GET.noToken(url, {
        setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg,
      });
      if (Array.isArray(data?.[0])) {
        setBatches(selectedClassId ? data[0].filter((batch) => batch.class_id === selectedClassId) : data[0]);
      } else setBatches([]);
    };
    fetchBatches();
  }, [selectedCourseId, selectedClassId]);

  useEffect(() => {
    if (DPPScheduleData?.course_id)
      setSelectedCourseId(Number(DPPScheduleData.course_id));
  }, [DPPScheduleData]);

  // useEffect(() => {
  //   if (!selectedBatchId || !batches.length) return;
  //   const matchedBatch = batches.find((b) => b.batch_id === selectedBatchId);
  //   if (matchedBatch) setSelectedBatchName(matchedBatch.batch_name);
  // }, [batches, selectedBatchId]);


  useEffect(() => {
    if (!Array.isArray(selectedBatchId) || selectedBatchId.length === 0 || !batches.length) return;
    const matchedNames = batches.filter((b) => selectedBatchId.includes(b.batch_id)).map((b) => b.batch_name).join(", ");
    if (matchedNames) setSelectedBatchName(matchedNames);
  }, [batches, JSON.stringify(selectedBatchId)]);

  useEffect(() => {
    const fetchSubjects = async () => {
      if (!selectedCourseId) return;
      const url = `${EndPoints.GetSubjectsByCourse}?course_id=${selectedCourseId}`;
      const data = await GET.noToken(url, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });
      if (data) setSubjects(data);
    };
    fetchSubjects();
  }, [selectedCourseId]);

  useEffect(() => {
    const fetchChapters = async () => {
      if (!selectedSubjectId) return;
      const url = `${EndPoints.GetChaptersBySubject}?subject_id=${selectedSubjectId}`;
      const data = await GET.noToken(url, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });
      if (data) setChapters(data);
    };
    fetchChapters();
  }, [selectedSubjectId]);

  useEffect(() => {
    const fetchTopics = async () => {
      if (
        !selectedChapterId ||
        !Array.isArray(selectedChapterId) ||
        selectedChapterId.length === 0
      ) {
        setTopics([]);
        return;
      }
      const data = await POST.withToken(
        EndPoints.TopicsByChapterList,
        selectedChapterId,
        { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
      );
      if (data && data.status_code === 200 && Array.isArray(data.data))
        setTopics(data.data);
      else setTopics([]);
    };
    fetchTopics();
  }, [selectedChapterId]);

  useEffect(() => {
    const fetchClasses = async () => {
      const data = await GET.noToken(EndPoints.GetClasses, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });
      if (data) setClasses(data);
    };
    fetchClasses();
  }, []);

  const isCancelled = searchParams.get("isCancelled") === "true";

  // ── handleSave — all date validation happens here ─────────────────────────
  const handleSave = async () => {
    // ── Validate start date (only if it was changed from saved value) ─────────
    const startWasEdited = testStartDate !== savedStartDateRef.current;
    if (startWasEdited && canEditStartDate) {
      const minAllowed = getCurrentDateTime(); // server time + 15 min
      if (testStartDate && testStartDate < minAllowed) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                DPP window start must be at least 15 minutes from current time.
                Please correct the start time before saving.
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
        return;
      }
    }

    // ── Validate end date (only if it was changed from saved value) ───────────
    const endWasEdited = testEndDate !== savedEndDateRef.current;
    if (endWasEdited) {
      // End cannot be reduced below last saved value
      const savedEnd = savedEndDateRef.current;
      if (savedEnd && testEndDate < savedEnd) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                DPP window end can only be extended beyond the last saved value,
                not reduced.
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
        return;
      }
    }

    // ── End must be after start ───────────────────────────────────────────────
    if (testStartDate && testEndDate && testEndDate <= testStartDate) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>DPP window end must be after the DPP window start.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
      return;
    }

    // ── End must be at least 24 hours after start ─────────────────────────────
    if (
      testStartDate &&
      testEndDate &&
      testEndDate < getMinEndDate(testStartDate)
    ) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              DPP window end must be at least 24 hours after the start time.
            </span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
      return;
    }

    if (fillInTheBlanksSuggestions === null || fillInTheBlanksSuggestions === undefined) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please select Fill in the Blanks Suggestions option.</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      return;
    }

    const payload = {
      ques_paper_id: selectedQuestionPaperId,
      dpp_name: dppName,
      dpp_desc: DppDescription,
      batch_id_list: Array.isArray(selectedBatchId) && selectedBatchId.length > 0 ? selectedBatchId : [],
      student_group_ids: Array.isArray(selectedStudentGroupIds) && selectedStudentGroupIds.length > 0 ? selectedStudentGroupIds : [],
      dpp_window_start: testStartDate,
      dpp_window_end: testEndDate,
      username: userName,
      status: 1,
      fill_in_the_blanks_suggestions: fillInTheBlanksSuggestions,
    };

    if (canEditInstructions) {
      payload.instructions_html = instructionsHtml;
    }

    const url = `${EndPoints.PutUpdateDppSchedule}?dpp_schedule_id=${dppScheduleId}`;
    const data = await PUT.withToken(url, payload, {
      setMessageBox,
      setIsMessageBoxVisible,
      setActiveImg,
      ErrorImg,
    });

    if (data && data.status === 200) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{data.message || "DPP schedule updated successfully!"}</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(SucessImg);
      // ── Update saved refs and lock form back to read-only on success ──────
      savedStartDateRef.current = testStartDate;
      savedEndDateRef.current = testEndDate;
      setIsEditMode(false);
      setTimeout(() => {
        navigate(-1);
      }, 1000);
    } else if (data && data.status === 400) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{data.message}</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      // reset fill_in_the_blanks_suggestions to saved value
      setFillInTheBlanksSuggestions(DPPScheduleData?.fill_in_the_blanks_suggestions ?? null);
    }else if (data) {
      setMessageBox(
        "Failed to update DPP Schedule: " + (data.detail || data.message)
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      // ── Keep form in edit mode on failure so user can correct ────────────
    }
  };

  // ── Free date handlers — just update state, validation on SAVE ────────────
  const handleStartDateChange = (e) => {
    if (!canEditStartDate) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              Start date cannot be changed after the DPP window has started.
            </span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
      return;
    }
    const newStartDate = e.target.value;
    setTestStartDate(newStartDate);
    // Auto-fill end to start + 24h (UX convenience, not validation)
    if (newStartDate) setTestEndDate(getMinEndDate(newStartDate));
  };

  const handleDownload = async () => {
    try {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Downloading DPP, please wait...</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(false);

      const url = `${EndPoints.PDF_DOWNLOAD_DPP_SCHEDULE}?dpp_schedule_id=${dppScheduleId}`;
      const response = await fetch(url, {
        method: "GET",
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (!response.ok) throw new Error("Failed to download PDF");

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = dppName
        ? `${dppName.replace(/\.pdf$/i, "")}.pdf`
        : `dpp_${dppScheduleId}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>DPP downloaded successfully!</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(SucessImg);
      setTimeout(() => setIsMessageBoxVisible(false), 2000);
    } catch (err) {
      console.error(err);
      setMessageBox("Error downloading PDF");
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
    }
  };

  return (
    <div className="create-role-container dpp-scheduling-page">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">DPP Scheduling</span>
        <div
          className="cr-header-btn-container"
          style={{
            minWidth: "fit-content",
            maxWidth: "fit-content",
            gap: "12px",
          }}
        >
          <button
            className="create-test-section-btn"
            style={{
              width: "100px",
              padding: "0 14px",
              borderWidth: "2px",
              borderStyle: "solid",
            }}
            onClick={() => navigate(-1)}
          >
            CANCEL
          </button>

          {!isEditMode && canDeleteSchedule && !isCancelled && (
            <button
              className="create-test-section-btn"
              style={{
                width: "100px",
                padding: "0 14px",
                borderWidth: "2px",
                borderStyle: "solid",
              }}
              onClick={() => setShowRejectModal(true)}
            >
              DELETE
            </button>
          )}

          {!isEditMode ? (
            <button
              className="create-test-section-btn"
              style={{
                width: "100px",
                padding: "0 14px",
                borderWidth: "2px",
                borderStyle: "solid",
                backgroundColor: isCancelled ? "#d3d3d3" : "",
                cursor: isCancelled ? "not-allowed" : "pointer",
                opacity: isCancelled ? 0.6 : 1,
              }}
              onClick={!isCancelled ? () => setIsEditMode(true) : undefined}
              disabled={isCancelled}
            >
              EDIT
            </button>
          ) : (
            <button
              className="create-test-section-btn"
              style={{
                width: "100px",
                padding: "0 14px",
                borderWidth: "2px",
                borderStyle: "solid",
              }}
              onClick={handleSave}
            >
              SAVE
            </button>
          )}

          <button
            className="create-test-section-btn"
            style={{
              width: "100px",
              padding: "0 14px",
              borderWidth: "2px",
              borderStyle: "solid",
            }}
            onClick={handleDownload}
          >
            DOWNLOAD
          </button>
        </div>
      </div>

      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>QUESTION PAPER DETAIL</label>
          </div>
        </div>

        <div className="accordion-content">
          <div className="select-assign-test-container-ques-pap-del">
            <div className="grid-container-ques-paper-del">
              <div><InputComponent label="Course" style={{ width: "100%" }} value={selectedCourseName || ""} isRequired={false} disable={true} /></div>
              <div><InputComponent label="Class" style={{ width: "100%" }} value={selectedClassName || ""} isRequired={false} disable={true} /></div>
              {/* <div><InputComponent label="Batch Name" style={{ width: "100%" }} value={selectedBatchName || ""} isRequired={false} disable={true} /></div> */}
              <div>
                <MultiSelectSearchDropdown
                  label="Batch Name" width="100%" selected={Array.isArray(selectedBatchId) ? selectedBatchId : []}
                  setSelected={(selectedIds) => {
                    setSelectedBatchId(selectedIds);
                    setSelectedBatchName(
                      batches.filter((b) => selectedIds.includes(b.batch_id)).map((b) => b.batch_name).join(", ")
                    );
                  }}
                  options={batches.map((batch) => ({ label: batch.batch_name, id: batch.batch_id }))}
                  isRequired={false} placeholder="Select Batch..." singleSelect={false}
                  disabled={!isEditMode || !canEditBatch}
                />
              </div>
              <div><InputComponent label="Student Group" style={{ width: "100%" }} value={selectedStudentGroup || ""} isRequired={false} disable={true} /></div>
              <div><InputComponent label="Subject" style={{ width: "100%" }} value={selectedSubjectName || ""} isRequired={false} disable={true} /></div>
              <div><InputComponent label="Chapter" style={{ width: "100%" }} value={selectedChapterName || ""} isRequired={false} disable={true} /></div>
              <div><InputComponent label="Topic" style={{ width: "100%" }} value={selectedTopicName || ""} isRequired={false} disable={true} /></div>
              <div><InputComponent label="Question Paper Name" style={{ width: "100%" }} value={selectedQuestionPaperName || ""} isRequired={false} disable={true} /></div>
              <div><InputComponent label="Question Paper Subjects" style={{ width: "100%" }} value={quesPaperSubjects} isRequired={false} disable={true} /></div>
              <div><InputComponent label="Question Paper Created By" style={{ width: "100%" }} value={selectedQuestionPaperCreatedBy} isRequired={false} disable={true} /></div>
              <div style={{ gridColumn: "2 / 4" }}><InputComponent label="Question Paper Description" style={{ width: "100%" }} value={selectedQuestionPaperDescription} isRequired={false} disable={true} /></div>
              <div>
                <InputComponent
                  label="Course"
                  style={{ width: "100%" }}
                  value={selectedCourseName || ""}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div>
                <InputComponent
                  label="Class"
                  style={{ width: "100%" }}
                  value={selectedClassName || ""}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div>
                <InputComponent
                  label="Batch Name"
                  style={{ width: "100%" }}
                  value={selectedBatchName || ""}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div>
                <InputComponent
                  label="Student Group"
                  style={{ width: "100%" }}
                  value={selectedStudentGroup || ""}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div>
                <InputComponent
                  label="Subject"
                  style={{ width: "100%" }}
                  value={selectedSubjectName || ""}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div>
                <InputComponent
                  label="Chapter"
                  style={{ width: "100%" }}
                  value={selectedChapterName || ""}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div>
                <InputComponent
                  label="Topic"
                  style={{ width: "100%" }}
                  value={selectedTopicName || ""}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div>
                <InputComponent
                  label="Question Paper Name"
                  style={{ width: "100%" }}
                  value={selectedQuestionPaperName || ""}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div>
                <InputComponent
                  label="Question Paper Subjects"
                  style={{ width: "100%" }}
                  value={quesPaperSubjects}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div>
                <InputComponent
                  label="Question Paper Created By"
                  style={{ width: "100%" }}
                  value={selectedQuestionPaperCreatedBy}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div style={{ gridColumn: "2 / 4" }}>
                <InputComponent
                  label="Question Paper Description"
                  style={{ width: "100%" }}
                  value={selectedQuestionPaperDescription}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div>
                <FormInputs
                  label="DPP Name"
                  value={dppName}
                  onChange={(e) => setDppName(e.target.value)}
                  placeholder="Enter DPP name"
                  style={{ width: "100%" }}
                  disabled={!isEditMode}
                />
              </div>
              <div>
                <FormInputs
                  label="Description"
                  value={DppDescription}
                  onChange={(e) => setDppDescription(e.target.value)}
                  placeholder="Enter Description"
                  style={{ width: "100%" }}
                  disabled={!isEditMode}
                />
              </div>
              <div>
              <SelectedValueDropdwon
                key={String(fillInTheBlanksSuggestions)}
                label="Fill in the blanks - Suggestions"
                style={{ width: "100%" }}
                selected={fillInTheBlanksSuggestions}
                setSelected={(id) => {
                  setFillInTheBlanksSuggestions(id);
                }}
                options={[
                  { label: "Enable", id: true },
                  { label: "Disable", id: false },
                ]}
                isRequired={true}
                disabled={!isEditMode}
              />
              </div>
              <div>
                <InputComponent
                  label="Batch Coordinator Name"
                  style={{ width: "100%" }}
                  value={CordinatorName}
                  isRequired={false}
                  disable={true}
                />
              </div>

              {/* ── DPP Window Start — free input, all validation on SAVE ─── */}
              <FormInputs
                label="DPP Window Start"
                type="datetime-local"
                value={
                  testStartDate ? formatDateTimeForInput(testStartDate) : ""
                }
                min={getCurrentDateTime()}
                onChange={handleStartDateChange}
                style={{
                  width: "100%",
                  opacity: isEditMode && canEditStartDate ? 1 : Colors.opacity,
                  cursor:
                    isEditMode && canEditStartDate ? "text" : "not-allowed",
                }}
                disabled={!isEditMode || !canEditStartDate}
              />

              {/* ── DPP Window End — free input, all validation on SAVE ───── */}
              <FormInputs
                label="DPP Window End"
                type="datetime-local"
                min={getMinEndDate()}
                value={testEndDate ? formatDateTimeForInput(testEndDate) : ""}
                onChange={(e) => {
                  // Just update freely — validation on SAVE
                  setTestEndDate(e.target.value);
                }}
                style={{
                  width: "100%",
                  opacity: isEditMode ? 1 : Colors.opacity,
                  cursor: isEditMode ? "text" : "not-allowed",
                }}
                disabled={!isEditMode}
              />
            </div>
          </div>

          <div className="dpp-instructions-wrapper">
            <div style={{ position: "relative" }}>
              {(!isEditMode || !canEditInstructions) && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: Colors.color5,
                    zIndex: 10,
                    pointerEvents: "all",
                    cursor: "not-allowed",
                    borderRadius: "4px",
                  }}
                />
              )}
              <TextEditor
                templates={testTemplates}
                value={instructionsHtml}
                setValue={(newValue) => {
                  if (!canEditInstructions && isEditMode) {
                    setMessageBox(
                      <div className="Container-messageBOX">
                        <div className="messagebox-insider1">
                          <div className="loader-tc"></div>
                          <span>
                            Instructions cannot be changed after the DPP window
                            has started.
                          </span>
                        </div>
                      </div>
                    );
                    setActiveImg(ErrorImg);
                    setIsMessageBoxVisible(true);
                    return;
                  }
                  setInstructionsHtml(newValue);
                }}
                disabled={!canEditInstructions}
              />
            </div>
          </div>
        </div>
      </div>

      <RejectModal
        isOpen={showRejectModal}
        onClose={() => setShowRejectModal(false)}
        onSubmit={(comment) => {
          setShowRejectModal(false);
          handleCancelDppScheduleWithComment(comment);
        }}
        title="Cancel DPP Schedule"
        placeholder="Enter reason for cancelling the DPP schedule..."
        setMessageBox={setMessageBox}
        setIsMessageBoxVisible={setIsMessageBoxVisible}
        setActiveImg={setActiveImg}
        errorImg={ErrorImg}
      />
    </div>
  );
};

export default DPPSchedulingClone;